(function () {
  function getLinesText(el) {
    return (el.innerText || "")
      .split("\n")
      .map(s => s.trim())
      .filter(Boolean);
  }

  function measureLineWidth(line, el) {
    const measure = document.createElement("span");
    measure.style.position = "absolute";
    measure.style.left = "-99999px";
    measure.style.top = "-99999px";
    measure.style.visibility = "hidden";
    measure.style.whiteSpace = "nowrap";

    measure.style.font = getComputedStyle(el).font;

    measure.textContent = line;
    document.body.appendChild(measure);
    const w = measure.getBoundingClientRect().width;
    document.body.removeChild(measure);
    return w;
  }

  function fitElementToViewport(el, { min = 12, max = 500 } = {}) {
    const baseFont = parseFloat(getComputedStyle(el).fontSize) || 16;

    el.style.fontSize = baseFont + "px";

    const lines = getLinesText(el);
    if (!lines.length) return;

    let longest = 0;
    for (const line of lines) {
      const w = measureLineWidth(line, el);
      if (w > longest) longest = w;
    }
    if (!longest) return;

    const targetWidth = document.documentElement.clientWidth;

    const scale = (targetWidth / longest) * 1.03;
    let newSize = baseFont * scale;

    newSize = Math.max(min, Math.min(max, newSize));

    el.style.fontSize = newSize + "px";

    el.classList.add('active');
  }

  function debounce(fn, wait = 80) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  function fitAll() {
    document.querySelectorAll(".js-hero-full-width-text").forEach(el => {
      fitElementToViewport(el, { min: 20, max: 500 });
    });
  }

  const fitAllDebounced = debounce(fitAll, 80);

  window.addEventListener("load", fitAll);
  window.addEventListener("resize", fitAllDebounced);

  if (window.ResizeObserver) {
    const ro = new ResizeObserver(fitAllDebounced);
    ro.observe(document.documentElement);
  }
})();